const COMPONENT_NAME = "tab-contents";
const CLASS_SELECTOR = ".TabContentContainer";
const INNER_SELECTOR = ".TabContentContainer-inner";
const VARIANT_SYNCED = "TabContentContainer--synced";
const TAB_CONTENT_SELECTOR = ".TabContent,[data-tab-content]";

const instances = [];

function initialize(element, PageComponents) {
    if (element.classList.contains(VARIANT_SYNCED)) {
        const innerElement = element.querySelector(INNER_SELECTOR);
        const contentElements = element.querySelectorAll(TAB_CONTENT_SELECTOR);
        function sync() {
            let maxHeight = 0;
            contentElements.forEach((content) => {
                maxHeight = Math.max(maxHeight, content.offsetHeight);
            });
            innerElement.style.height = maxHeight + 'px';
        }

        PageComponents.afterLoad(() => {
            window.addEventListener('resize', sync);
            sync();
        });
    }
}

export default {
    name: COMPONENT_NAME,
    instances,
    initialize
};
